import React, {useState, useEffect} from 'react';
import envelope from '../../../assets/images/icon-envelope.svg';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import useApiGetWithToken from '../../../DataServices/useApiGetWithToken';
import postApiWithToken from '../../../DataServices/postApiWithToken';
import LoadingIndicator from '../../../Layout/LoadingIndicator';
import { protectedResources } from "../../../authConfig";
import axios from 'axios';
import Checkbox from '../../Common/Checkbox';
import Subscriptions from './Subscriptions';
import { Link, useHistory } from 'react-router-dom';
import TagManager from 'react-gtm-module';

 
const tagManagerArgs = {
    dataLayer: {
        page: 'my-preferences',
        event:'spa-pageview'
    }
}

// Container component for Email Preferences page.
const MyPreferences = (props) => {
  // This state will be populated with the Axios HTTP response.
  // In some cases customer doesn't have preferences and we need to set the defaults.
  const [preferences, setPreferences] = useState(
    {
      fclAg: false,
      fclContractorsChoice: false,
      fclFood: false,
      fclFuel: false,
      fclHome: false,
      fclPharmacy: false,
      fclSocialResponsibility: false,
      fclCommercialFuel: false,
      company: '',
      phoneNumber: '',
      research: false,
      tradeSpeciality: '',
      unsub_fcl_consumerproducts: false
    }
  );
  
  const [showSubscriptions, setShowSubscriptions] = useState(false);
  const [signUp, setSignUp] = useState(false);
  const [showContract, setShowContract] = useState(false);
  const [recipient, setRecipient] = useState();
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setIsLoading] = useState(false);
  const history = useHistory();
  props.setPage('my-retail');
  
  // Preferences are retrieved from the API by passing the current customer's email address.
  const { data, error, isLoaded } = useApiGetWithToken("/customerPreferences/"+props.customer.email);

  useEffect(() =>{
    TagManager.dataLayer(tagManagerArgs)
  }, [])

  useEffect(() => {
    if (isLoaded) {
      if (data) {
        // Email exists in Acoustic and preferences are known.
        setPreferences(data);
        setRecipient(data.recipientID);
        setSignUp(!data.unsub_fcl_consumerproducts);
        setShowSubscriptions(data.unsub_fcl_consumerproducts ? false : true);
        setShowContract(data.fclContractorsChoice ? true : false);
      } else 
      {
        // This customer doesn't have acoustic account. 
        setPreferences(
          {
            ...preferences,
            firstName: props.customer.firstName,
            lastName: props.customer.lastName,
            postalCode: props.customer.postalCode,
            email: props.customer.email,
            emailConfirm: props.customer.email,
            sourceURL: "cdp",
            sub: props.customer.sub
          }
        )
        setSignUp(false);
        setShowSubscriptions(false);
      }
    }
  }, [data]);

  // Changing preferences by clicking on the checkbox.
  const handleChange = e => {
    let t = preferences[e.target.name];
    if (e.target.name==="signUp") {
      // Special case – user is either subscribing or unsubscribing.
      setSignUp(true);
      setShowSubscriptions(true);
    } else {
      // Checkbox is set to the oposite of previous state.
      setPreferences({...preferences, [e.target.name]: !t})
    }
    
    if (e.target.name==="fclContractorsChoice") {
      // When user clicks on Contractors choics we need to display additional form.
      setShowContract(!t ? true : false);
    } else if (e.target.name==="signUp") {

    }
    if (isDisabled) setIsDisabled(false)
  }

  useEffect(() => {
    if (loading) {
        // If this customer doesn't have acoustic account 
        // we will need primary retail. Also we want to update primary or other details if they changed.
        props.authProps.instance.acquireTokenSilent({
          scopes: protectedResources.api.scopes,
          account: props.authProps.account
        }).then((response) => {
          axios
          .get("/customerRetail/"+props.customer.sub, {
              headers: {
                  'Authorization': 'Bearer ' + response.accessToken
              }
              })
          .then(response => {
            (async() => {
              setIsDisabled(true);
              const newPrefs = {
                ...preferences,
                firstName: props.customer.firstName,
                lastName: props.customer.lastName,
                retailId: response.data.filter(loc => loc.isPrimary === true)[0]?.retailID,
                postalCode: props.customer.postalCode,
                email: props.customer.email,
                emailConfirm: props.customer.email,
                sub: props.customer.sub
                };
                await postApiWithToken(
                  props.authProps.account, 
                  props.authProps.instance, 
                  props.authProps.inProgress, 
                  '/customerPreferences/', 
                  newPrefs);
                  setIsLoading(false)
                  props.setPage('home')
                  history.push("/")
            })()
          })
          .catch(error => {
              console.log(error);
          });
        })
    }
  }, [loading])
  
  // Submit is handling via useEffect. Setting the loading to true to enable loader.
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true) 
  } 

  // Controls changes for the contractor's choice form.
  const handleContractorChoice = e => {
    setPreferences({...preferences, [e.target.name]: e.target.value})
    if (isDisabled) setIsDisabled(false)
  }
  
  // If user wants to unsubscribe this will show alert asking for confirmation.
  const unsubscribe = (e) => {
    e.preventDefault();
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='fcl-confirm'>
            <h1>Unsubscribe</h1>
            <p>It looks like you're trying to unsubscribe. <br />Are you sure?</p>
            <div className="buttons">
              <button className="primary" onClick={onClose} autoFocus>No</button>
              <button
                className="secondary"
                onClick={async () => {
                  // Send a request to api to unsubscribe the customer.
                  const r = await postApiWithToken(
                  props.authProps.account, 
                  props.authProps.instance, 
                  props.authProps.inProgress, 
                  '/customerUnsubscribe/', 
                  {
                    "email":props.customer.email,
                    "recipientID":recipient
                  });
                  props.setPage('home');
                  history.push("/")
                  onClose();
                }}
              >
                Yes, I would like to unsubscribe.
              </button>
            </div>
          </div>
        );
      }
    });
    
  }
  
  if (error !== null) {
    return <div>Error: {error.message}</div>;
  }
  // Display loadier overlay while the data is loading. 
  // Shows up on the initail customer load and on saves.
  if (!isLoaded || loading) {
    return <LoadingIndicator />;
  }

  // Returns the container for the email preferences page.
  // It will call Subscriptions component if applicable.
  return (
    <form onSubmit={handleSubmit}>
        <div className="my-preferences">
          <h2>My Email Preferences</h2>
          <div className="row">
            <div className="check">
              <Checkbox 
                name="signUp" 
                checked={signUp}  
                onChange={signUp? unsubscribe:handleChange} 
                aria-label="Sign up" 
              />
            </div>
            <img src={envelope} alt="sign up" />
            <div className="description">
              <strong>Sign up for Email</strong> - By checking this box you can receive the latest email offers and communications from Co-op. You can unsubscribe at any time.
            </div>
          </div>

          {showSubscriptions ? <Subscriptions
            preferences = {preferences}
            handleContractorChoice = {handleContractorChoice}
            handleChange = {handleChange}
            showContract = {showContract}
            /> : ''
          }

          <div className="buttons">
            <button 
              type="submit" 
              className="save btn primary" 
              disabled={isDisabled} 
              aria-label="Save"
            >Save</button>
            <Link
              type="button" 
              className="cancel btn secondary" 
              onClick={()=>props.setPage('home')} 
              to={'/'}
              aria-label="Cancel"
            >Cancel</Link>
          </div>
        </div>
      </form>
    );
}

export default MyPreferences;